<div class="search-wrapper">
    <mat-form-field appearance="outline" class="search-field">
        <mat-label>{{ placeholder }}</mat-label>

        <input matInput [(ngModel)]="searchTerm"  (keyup.enter)="onSearchClick()"
            [placeholder]="placeholder" />

        <button matSuffix mat-icon-button (click)="onSearchClick()">
            <mat-icon>search</mat-icon>
        </button>
    </mat-form-field>
    <div class="search-nav" *ngIf="totalMatches > 0">
        <span class="count">{{ currentIndex + 1 }} / {{ totalMatches }}</span>

        <button mat-icon-button (click)="prev()">
            <mat-icon>keyboard_arrow_up</mat-icon>
        </button>

        <button mat-icon-button (click)="next()">
            <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
    </div>
</div>